{
  "title": "ops 구성",
  "needCt": "room 관리 코드로 증명한 세션만 이 화면에 들어옵니다.",
  "needCtLink": "관리 코드 넣기",
  "ctSessionEnded": "이 CT 접속은 끝났습니다. 관리 코드를 다시 넣습니다. 맞지 않다고 나오면 코드가 바뀐 것이니 새 코드를 받습니다.",
  "ctSessionRotated": "관리 코드가 재발급되어 이 CT 접속이 끝났습니다. 재발급한 CT 에게 새 관리 코드를 받아 넣습니다.",
  "ctSessionOtherTab": "이 브라우저의 다른 탭이 CT 접속을 이어 쓰고 있어 이 탭의 접속은 끝났습니다. 그 탭에서 계속합니다. 그 탭을 닫았다면 이 탭을 새로고침합니다.",
  "ctSessionReloadTab": "이 탭 새로고침",
  "onboardingTitle": "이 room 을 여는 첫 걸음",
  "onboardingWhy": "여기 넣은 이름이 입장 두 번째 단계에 뜹니다. 채워지기 전에는 올바른 입장 코드도 거절됩니다.",
  "onboardingNickname": "CT 닉네임",
  "onboardingSave": "저장하고 열기",
  "drawerOpen": "접속 명단",
  "drawerClose": "닫기",
  "presenceTitle": "접속 명단",
  "presenceEmpty": "아직 아무도 들어와 있지 않습니다",
  "connections": "접속",
  "kick": "추방",
  "codesTitle": "코드 두 벌",
  "codesReveal": "드러내기",
  "codesHide": "가리기",
  "codesJoin": "공용 입장 코드",
  "codesAdmin": "room 관리 코드",
  "codesRotateJoin": "공용 코드 재발급",
  "codesRotateAdmin": "관리 코드 재발급",
  "codesRoomCount": "이 서버의 room 수",
  "codesIssuedAt": "마지막 발급",
  "codesWarning": "관리 코드 재발급은 공용 입장 코드를 건드리지 않습니다.",
  "whitelistTitle": "whitelist",
  "whitelistWhy": "명단에 없는 게임 ID 는 코드를 알아도 들어오지 못합니다.",
  "whitelistWhere": "사람을 올리고, 이름을 고치고, 명단에서 지우는 자리는 roster 탭의 명부입니다.",
  "whitelistEmpty": "아직 등록된 사람이 없습니다",
  "nextStepLabel": "다음",
  "nextSeedRoster": "roster 탭에서 아군을 올립니다",
  "nextAddMain": "main 을 만듭니다. 착탄축의 원점입니다",
  "nextAddSub": "sub 를 더하거나, 조립을 마칩니다",
  "nextSetHandle": "가장 이른 개시를 지금부터 언제에 둘지 정합니다",
  "nextDispatch": "confirm 합니다. 누르는 순간 시각이 확정됩니다",
  "rallyTitle": "rally 편집기",
  "rallyWhy": "왼쪽에서 한 줄씩 만들고 오른쪽에 쌓입니다. 여기까지는 절대 시각이 없습니다. 서로의 간격만 정합니다.",
  "formTitle": "rally 한 줄 만들기",
  "typeLabel": "타입",
  "typeMainTaken": "main 은 하나뿐입니다. 이미 있습니다",
  "needMainFirst": "main 을 먼저 만듭니다. 착탄 간격의 기준입니다",
  "rosterLabel": "맡을 roster",
  "rosterPick": "고르세요",
  "rosterNeed": "누가 맡을지 고르세요.",
  "rosterEmpty": "명부에 아군이 없습니다",
  "rosterNeedsMarching": "행군 필요",
  "rosterNeedsMarchingWhy": "{name} 의 행군 시간이 아직 없습니다. roster 탭 명부에서 먼저 넣습니다.",
  "rosterGone": "명부에서 내려간 사람",
  "rallyingLabel": "rallying",
  "rallyingLabelHint": "네 옵션의 결과를 함께 봅니다",
  "rallyingWhy": "rallying 이 길수록 그 줄은 더 일찍 엽니다. 착탄 자리는 그대로입니다.",
  "rallyingMinutes": "{n}분",
  "rallyingLeadFirst": "가장 먼저 엽니다",
  "rallyingLeadAfter": "가장 이른 개시 + {value}",
  "rallyingShift": "기존 줄이 {value} 밀립니다",
  "rallyingShiftNone": "기존 줄은 그대로입니다",
  "rallyingBlocked": "불가",
  "offsetLabel": "착탄 offset  = main 착탄 + Δ",
  "offsetMainZero": "main 의 착탄 간격은 0 입니다. main 이 착탄축의 원점입니다.",
  "confirmRally": "이 줄을 적재",
  "miniTitle": "시퀀스",
  "miniWhy": "적재할 때마다 즉시 쌓입니다. 방금 넣은 줄이 점선으로 표시됩니다. 정렬을 바꿔도 그 표시는 그 줄을 따라갑니다.",
  "miniEmpty": "아직 아무 줄도 없습니다. 왼쪽에서 main 을 먼저 만듭니다.",
  "miniFresh": "방금 적재",
  "miniRemove": "빼기",
  "miniMainLocked": "sub 가 남아 있어 main 을 뺄 수 없습니다. sub 를 먼저 뺍니다.",
  "columnRoster": "roster",
  "columnRallying": "rallying",
  "columnOpenDelta": "개시 Δ",
  "columnImpactDelta": "착탄 Δ",
  "openDeltaWhy": "가장 이른 개시 대비",
  "impactDeltaWhy": "main 착탄 대비",
  "sequenceConfirm": "조립 마치기",
  "sequenceConfirmWhy": "마치면 time handle 이 나타납니다. 그 전에는 time handle 도 confirm 도 화면에 없습니다.",
  "sequenceConfirmed": "조립을 마쳤습니다. 이제 시각을 정합니다.",
  "notFixedYet": "시각은 아직 확정되지 않았습니다. confirm 하는 순간 확정됩니다.",
  "handleTitle": "time handle",
  "handleTitleHint": "가장 이른 개시를 지금부터 얼마 뒤에 둘지",
  "handlePreset": "{value}초",
  "handleCustom": "직접 입력",
  "handleApply": "적용",
  "handleApplied": "가장 이른 개시를 지금부터 {value} 뒤에 둡니다.",
  "handleFloorWhy": "개시 직전 5초 동안 signal 을 냅니다. 그래서 6초보다 이르게는 둘 수 없습니다.",
  "dispatch": "confirm",
  "dispatchWhy": "누르는 순간 절대 시각이 확정되어 접속한 모두에게 나갑니다.",
  "dispatchBadge": "confirm 됨, 시각 확정",
  "dispatchBadgeWhy": "이 ops 의 시각은 확정됐습니다. 명부의 행군을 고쳐도 이 시퀀스는 움직이지 않습니다.",
  "reopen": "이 ops 수정",
  "reopenGo": "편집으로 되돌립니다",
  "reopenConfirm": "아래 버튼을 누르면 편집으로 돌아갑니다. rally {n} 줄이 모두 남습니다. 그 사이 명부에서 고친 행군이 있으면 개시 시각만 그 값으로 다시 계산됩니다.",
  "reopenOpenedNone": "아직 개시한 rally 가 없습니다.",
  "reopenOpenedSome": "이미 개시한 rally 가 {n} 줄 있습니다. 그 사람들의 카운트다운이 사라지고, 이미 나간 병력은 돌아오지 않습니다.",
  "reopenCancel": "취소",
  "reopened": "편집으로 돌아왔습니다. 편성은 그대로입니다. 줄을 고치고 시간을 다시 잡아 confirm 합니다.",
  "reopenWhy": "수정은 편성을 지키고 접기는 편성을 버립니다. 되돌리면 연맹원 화면의 카운트다운이 사라지고, 다시 confirm 해도 각자 들을 대상을 다시 골라야 합니다.",
  "discard": "이 ops 접기",
  "discardGo": "정말 접습니다",
  "discardConfirm": "아래 버튼을 누르면 이 ops 를 지웁니다. rally {n} 줄이 함께 사라지고 되돌릴 수 없습니다. 편성을 지키고 고치려면 취소하고 「이 ops 수정」을 누릅니다. 명부는 그대로 남습니다.",
  "discardCancel": "취소",
  "discarded": "ops 를 접었습니다. 새로 짭니다.",
  "cardCount": "rally {n} 줄",
  "retimeTitle": "다시 잡기",
  "retimeTitleHint": "편성은 그대로, 시각만",
  "retimeQuick": "30초 뒤로 다시 잡기",
  "retimeQuickWhy": "개시 시각만 바뀝니다. roster 배정과 rally 설정은 그대로입니다.",
  "retimeCustom": "직접 설정",
  "retimeApply": "적용",
  "retimeApplied": "잡혀 있는 값은 {value} 입니다.",
  "retimeMarching": "명부에서 고친 행군은 다시 잡을 때 반영됩니다.",
  "retimed": "다시 잡았습니다. 편성은 그대로입니다.",
  "editRally": "고치기",
  "editRallyClose": "취소",
  "editTitle": "{name}의 줄을 고칩니다",
  "editWhy": "착탄 간격과 rallying, 담당 roster 를 고칩니다. 행군은 명부에서만 고칩니다.",
  "editRosterLabel": "담당 roster 바꾸기",
  "editApply": "저장",
  "editUnsaved": "저장하지 않은 변경이 있습니다.",
  "editUnsavedSwitch": "버리면 {name}의 줄을 엽니다.",
  "editUnsavedClose": "버리면 편집을 닫습니다.",
  "editKeepEditing": "계속 편집",
  "editDiscard": "변경 버리기",
  "editChangedElsewhere": "다른 곳에서 이 줄이 바뀌었습니다. 손대지 않은 칸은 새 값으로 맞췄습니다.",
  "editDroppedRemote": "다른 곳에서 이 ops 를 수정하거나 접어 줄 수정이 닫혔습니다. 저장하지 않은 입력은 남지 않았습니다.",
  "leaveDropsEdit": "열려 있는 줄 수정의 저장하지 않은 입력도 사라집니다.",
  "edited": "고쳤습니다. main 착탄은 그대로입니다.",
  "counterTitle": "counter rally 붙이기",
  "counterWhy": "건물을 점령하면 그 건물에 rally 를 열 수 없습니다. 점령하기 전에 미리 열어 두고 긴 rallying 으로 버팁니다.",
  "counterMainFixed": "main 착탄은 이미 확정됐습니다. 새 줄은 그 기준에 붙습니다.",
  "rallyingLead": "개시 여유 {value}",
  "rallyingMinimumOffset": "간격이 {value} 이상이어야 붙습니다",
  "rallyingNoShift": "앞 줄은 밀리지 않습니다",
  "nextRetime": "다시 잡으면 같은 편성으로 곧바로 나갑니다",
  "retimeWillApply": "누르면 가장 이른 개시가 지금부터 {value} 뒤에 섭니다.",
  "counterAdded": "붙였습니다: {name}, 착탄 main {offset}. 앞 줄은 그대로입니다.",
  "rallyWhyCounter": "진행 중인 ops 에 한 줄을 더합니다. 붙이는 순간 그 줄의 착탄 시각이 정해집니다."
}
